import React from 'react'
import ContentLoader from 'react-content-loader'
import { LoaderContainer } from './mixins'

const InfoCardPlaceholder = props => {
  return (
    <ContentLoader
      speed={2}
      width="100%"
      height={48}
      viewBox="0 0 100% 48"
      backgroundcolor="#f3f3f3"
      foregroundColor="#ecebeb"
      {...props}
    >
      <rect x="0" y="0" rx="3" ry="3" width="48" height="48" />
      <rect x="64" y="24" rx="3" ry="3" width="100" height="24" />
      <rect x="64" y="0" rx="3" ry="3" width="170" height="20" />
    </ContentLoader>
  )
}

const SectionEstadisticasPlaceholder = props => {
  return (
    <LoaderContainer>
      <ContentLoader
        speed={2}
        width="100%"
        height={57}
        viewBox="0 0 100% 57"
        backgroundcolor="#f3f3f3"
        foregroundColor="#ecebeb"
        {...props}
      >
        <rect x="0" y="0" rx="3" ry="3" width="170" height="24" />
        <rect x="0" y="37" rx="3" ry="3" width="275" height="20" />
      </ContentLoader>
      <InfoCardPlaceholder style={{ marginTop: 13, marginBottom: 14 }} />
      <InfoCardPlaceholder style={{ marginTop: 13, marginBottom: 14 }} />
      <InfoCardPlaceholder style={{ marginTop: 13 }} />
    </LoaderContainer>
  )
}

export default SectionEstadisticasPlaceholder
